<fieldset style="display:flex; flex-direction:column" class="rms-fieldset">
  <legend style="font-size:12px">PO Search</legend>
  <div style="width:90%">
    <rms-radio label="Search By:"
               [options]="[
                          { value: 'PO #', label: 'PO #' },
                          { value: 'Reference #', label: 'Reference #' }
                        ]"
               [(ngModel)]="searchOption">
    </rms-radio>
  </div>
  <div style="width:90%">
    <rms-input [(ngModel)]="searchText"
               [label]="'Search By ' + searchOption">
    </rms-input>
  </div>
  <div class="text-right" style="margin-top: 8px;">
    <button mat-button class="btn-bg-blue" (click)="submitPoSearch();">Search</button>
    <button mat-button class="btn-bg-red" (click)="cancelSearch()">Cancel</button>
  </div>
</fieldset>
